import { Routes } from '@angular/router';

import { canMatchPdc } from './guards/can-match-pdc';
import { canDeactivatePdc } from './guards/can-deactivate-pdc';
import { canMatchMdt } from './guards/can-match-mdt';
import { canDeactivateMdt } from './guards/can-deactivate-mdt';

import { SimplePageComponent } from './layout/templates/simple-page/simple-page.component';
import { PageNotFoundComponent } from './views/pages/page-not-found/page-not-found.component';
import { HomeComponent } from './views/pages/home/home.component';
import { SessionCallbackComponent } from './views/session/callback/callback.component';
import { MissingConfigurationComponent } from './views/pages/missing-configuration/missing-configuration.component';
import { RouteWrapperComponent } from 'layout/route-wrapper/route-wrapper.component';

import { redirects } from './app.redirects';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/en',
    pathMatch: 'full'
  },
  ...redirects,
  {
    path: ':locale',
    component: RouteWrapperComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: RouteWrapperComponent,
        data: {
          redirectTo: 'home'
        }
      },
      {
        path: 'session/callback',
        component: SessionCallbackComponent
      },
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'missing-configuration',
        component: MissingConfigurationComponent
      },
      {
        path: 'mdt',
        loadChildren: () => import('./views/mdt/mdt.routes'),
        canMatch: [canMatchMdt],
        canDeactivate: [canDeactivateMdt],
        data: {
          roles: ['admin', 'support', 'sales', 'engineering', 'billing']
        }
      },
      {
        path: 'pdc/:tenant_id',
        loadChildren: () => import('./views/pdc/pdc.routes'),
        canMatch: [canMatchPdc],
        canDeactivate: [canDeactivatePdc]
      }
    ]
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'session/callback',
    component: SessionCallbackComponent
  },
  {
    path: '**',
    component: SimplePageComponent,
    children: [
      {
        path: '**',
        component: PageNotFoundComponent,
        data: {
          breadcrumb: '404'
        }
      }
    ]
  },
];
